// Last-N-days picker used by Paint Dashboard, Paint Usage, and Paint Inspections All Projects.
import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";

export const DAYS_OPTIONS = [1, 3, 7, 14, 30];
export const MAX_DAYS = 90;

export const parseDays = (value, { allowAll = false, fallback = 7 } = {}) => {
  if (allowAll && (value == null || value === "" || value === "all")) return null;
  const n = parseInt(value, 10);
  if (!_.isFinite(n) || n < 1) return allowAll ? null : fallback;
  return Math.min(n, MAX_DAYS);
};

const DaysSelector = ({ value, onChange, allowAll = false, variant = "default" }) => {
  const [customDays, setCustomDays] = useState(value == null ? "" : String(value));

  useEffect(() => {
    setCustomDays(value == null ? "" : String(value));
  }, [value]);

  const commit = (next) => {
    if (allowAll && (next == "all" || next === "")) {
      onChange(null);
      return;
    }
    onChange(parseDays(next, { fallback: value || 7 }));
  };

  if (variant == "dashboard") {
    return (
      <div className="pd-days">
        <span className="pd-days-label">Period</span>
        {_.map(DAYS_OPTIONS, (d) => (
          <button key={d} type="button" className={`pd-day-btn ${value == d ? "is-active" : ""}`} onClick={() => commit(d)}>
            {d}d
          </button>
        ))}
        <input
          className="pd-day-input"
          type="number"
          min="1"
          max={MAX_DAYS}
          value={customDays}
          onChange={(e) => setCustomDays(e.target.value)}
          onBlur={() => commit(customDays)}
          onKeyDown={(e) => {
            if (e.key == "Enter") commit(customDays);
          }}
          title="Custom days"
        />
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center flex-wrap" style={{ gap: 6 }}>
      <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#6c757d" }}>
        Period
      </span>
      {allowAll && (
        <Button size="sm" color="primary" outline={value != null} onClick={() => commit("all")}>
          All
        </Button>
      )}
      {_.map(DAYS_OPTIONS, (d) => (
        <Button key={d} size="sm" color="primary" outline={value != d} onClick={() => commit(d)}>
          {d}d
        </Button>
      ))}
      <input
        type="number"
        min="1"
        max={MAX_DAYS}
        value={customDays}
        onChange={(e) => setCustomDays(e.target.value)}
        onBlur={() => commit(customDays)}
        onKeyDown={(e) => {
          if (e.key == "Enter") commit(customDays);
        }}
        title="Custom days"
        style={{ width: 64, height: 31, textAlign: "center" }}
      />
    </div>
  );
};

export default DaysSelector;
